const getEnumId = (enumName: string) => {
  return enumName
}

export default getEnumId
